<template>
  <div class="h-100">
    <div
      v-if="test"

      id="test-result"
      class="container text-center"
    >
      <Loader v-if="isLoading" />
      <h1 class="mb-5">
        {{ $t('test.result') }}:
      </h1>
      <img
        :src="test[`${randomlySelectedResult}Img`]"
        alt=""
        width="300"
        class="mb-5"
      >
      <h3>{{ test[randomlySelectedResult + 'Desc'] }}</h3>
    </div>
  </div>
</template>
<script>
import Loader from '@/components/Loader';

import { API } from '@/services/';
import { API_BASE_URL, API_GET_TEST_BY_ID } from '@/helpers/config';

export default {
  components: {
    Loader,
  },
  data: () => ({
    apiBaseUrl: API_BASE_URL,
    isLoading: true,
    test: null,
    randomlySelectedResult: null,
  }),
  created() {
    window.fbq('track', 'BasariliTest');

    this.getTest();
  },
  methods: {
    selectInstagramAccount() {
      this.$router.push(`/instagram?testId=${this.$route.params.id}&userId=${this.$route.query.userId}`);
    },
    getRandomResult(arr) {
      // get a random index number
      const rand = Math.floor(Math.random() * arr.length);

      // return random result name -> exm. arr[0] -> result answerOne
      return arr[rand];
    },
    getTest() {
      const url = API_GET_TEST_BY_ID + this.$route.params.id;

      API.get(url).then((response) => {
        this.test = response.data;

        // get random result name to use it in template
        this.randomlySelectedResult = this.getRandomResult(['answerOne', 'answerTwo']);
        this.isLoading = false;
      }).catch((error) => {
        if (error.response.status === 204 || error.response.status === 400) this.$router.push('/404');
      });
    },
  },
};
</script>
